import React, { useEffect, useState,  } from 'react'
import { Modal, Steps, Form, Space, App} from 'antd'        
import Icon from '../../../cpn/Icon';
import UserSelect from '../../user/UserSelect';
import { useFKspjdPLAddMutation, useFKspjdListQuery } from '../../../store/DianShangYeWuApi';
function CostNodeCopyAdd(props) {    
    const { message } = App.useApp();
    const [open, setOpen] = useState(false);
    const [submitAdd] = useFKspjdPLAddMutation()    
    const {data, isSuccess} = useFKspjdListQuery({ddzc_spjd_qy_id:props.qy_id,ddzc_spjd_user_id:props.ddzc_spjd_user_id},{skip:!open});
    const [items, setItems] = useState([]);
    const [form] = Form.useForm();
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){
                const newArr = data.Result.map(item => {
                    const {ddzc_spjd_id:key,ddzc_spjd_name,ddzc_spjd_yh_name,ddzc_spjd_xuhao,ddzc_spjd_yh_id} = item;
                    return {
                        key,
                        title: ddzc_spjd_name + '：' + ddzc_spjd_yh_name,
                        content: '',
                        ddzc_spjd_xuhao: ddzc_spjd_xuhao,
                        ddzc_spjd_yh_id: ddzc_spjd_yh_id,
                        ddzc_spjd_yh_name: ddzc_spjd_yh_name,
                        ddzc_spjd_name: ddzc_spjd_name,
                        status: 'wait',
                    }
                })
                const sortArr = newArr.sort( (a, b) => {
                    return a.ddzc_spjd_xuhao - b.ddzc_spjd_xuhao;
                })                    
                setItems(sortArr);
                
            } else {
                setItems([]);
            }
        }
    },[data, isSuccess, props.qy_id, props.user_id, props.user_name])    
    // eslint-disable-next-line no-unused-vars
    const [user, setUser] = useState({ddzc_spjd_user_id:'',ddzc_spjd_user_name:''});
    const onAdd = () => {
        if(!user.ddzc_spjd_user_id || !user.ddzc_spjd_user_name){
            message.error("请先选择付款单操作员");
            return;
        }
        let obj ={
            'ddzc_spjd_qy_id': props.qy_id,
            'ddzc_spjd_qy_name': props.qy_name,
            'ddzc_spjd_xuhao': '',
            'ddzc_spjd_name': '',
            'ddzc_spjd_yh_id': '',
            'ddzc_spjd_yh_name': '',
            'ddzc_spjd_uid': props.yh_id,
            'ddzc_spjd_uname': props.yh_name,
            'ddzc_spjd_content': '',
            'ddzc_spjd_user_id': user.ddzc_spjd_user_id,
            'ddzc_spjd_user_name': user.ddzc_spjd_user_name,
        }
        // 1. 校验填单人
        if (!user.ddzc_spjd_user_id || !user.ddzc_spjd_user_name) {
                message.error("请先选择付款单操作员");
            return;
        }
        // 2. 校验 items 节点
        if (!items || items.length === 0 || (items.length === 1 && !items[0].ddzc_spjd_yh_id)) {
            message.error("请设置至少一个审批/抄送节点");
            return;
        }
        // 3. 过滤掉无效节点
        const validItems = items.filter(item => !!item.ddzc_spjd_yh_id && !!item.ddzc_spjd_yh_name);

        // 4. 填充 obj 字段
        // 不需要前面1,2两个元素了，直接从items的第一个开始
        // 填充序号
        let s = validItems.length;
        let xuhaoArr = [];
        for(let i=1; i<=s; ++i) xuhaoArr.push(i);
        obj.ddzc_spjd_xuhao = xuhaoArr.join(',');

        // 填充ddzc_spjd_name
        obj.ddzc_spjd_name = validItems.map(item => item.ddzc_spjd_name).join(',');

        // 填充ddzc_spjd_yh_id
        obj.ddzc_spjd_yh_id = validItems.map(item => item.ddzc_spjd_yh_id).join(',');

        // 填充ddzc_spjd_yh_name
        obj.ddzc_spjd_yh_name = validItems.map(item => item.ddzc_spjd_yh_name).join(',');

        // 填充ddzc_spjd_content
        obj.ddzc_spjd_content = validItems.map(item => item.content || '').join(',');

        // 5. 提交
        submitAdd(obj).then(res => {
            if (res && res.data && res.data.Status === 'success') {
                message.success('复制新增成功');
                setOpen(false);
                setItems([]);
                setUser({ddzc_spjd_user_id:'',ddzc_spjd_user_name:''});
                props.onSuccess && props.onSuccess();
            } else {
                message.error('复制新增失败：' + (res?.data?.Message || '未知错误'));
            }
        });
    }
    return (
        <>
            <Icon 
                type='copy' 
                onClick={() => {
                    setOpen(true);
                    
                }}  
            title='复制新增'
        />
            <Modal
                open={open}
                onCancel={() => {
                    setOpen(false);
                    setUser({ddzc_spjd_user_id:'',ddzc_spjd_user_name:''});
                }}
                onOk={() => {}}
                footer={null}
                title='复制新增'
            >
                <Form 
                    form={form} 
                    layout='horizontal' 
                    labelCol={{ span: 8 }}
                    name={`form_${props.ddzc_spjd_user_id}`}
                >
                   
                    <Form.Item label="付款单审批点">                        
                        <div>
                            <style>
                                {`
                                    .ant-steps-item-title {
                                        color: #000 !important;
                                    }
                                `}
                            </style>
                            <Steps
                                items={items}
                                orientation="vertical"  
                                size="small"
                                current={items.length-1}
                            />
                        </div>
                    </Form.Item>
                    <UserSelect
                        qy_id={props.qy_id}
                        onChange={(value) => {
                            setUser({ddzc_spjd_user_id:value.yh_id,ddzc_spjd_user_name:value.yh_name});
                        }}
                        label="复制给操作员"
                        name="ddzc_spjd_user_id"
                        required
                        wrapperCol={{ span: 12 }}
                        placeholder="请选择操作员"
                    /> 
                    <Form.Item wrapperCol={{ offset: 8,}}>
                        <Space size={30}>                            
                            <Icon 
                                type='save' 
                                onClick={onAdd} 
                                title='保存' 
                                key='save'
                            />                            
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
export default CostNodeCopyAdd